// extracted by mini-css-extract-plugin
export var black = "_45-6";
export var brand = "_45-1";
export var ddefault = "_45-0";
export var error = "_45-3";
export var gray = "_45-2";
export var highContrast = "_45-8";
export var outline = "_45-7";
export var success = "_45-5";
export var warning = "_45-4";